import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import Landing from "@/pages/Landing";
import Success from "@/pages/Success";
import Policy from "@/pages/Policy";
import Track from "@/pages/Track";
import { Toaster } from "sonner";
import MetaPixelRouteTracker from "@/components/MetaPixelRouteTracker";

// Admin (code-split — only loaded when /admin is visited)
const AdminLogin = lazy(() => import("@/pages/admin/AdminLogin"));
const AdminLayout = lazy(() => import("@/pages/admin/AdminLayout"));
const Dashboard = lazy(() => import("@/pages/admin/Dashboard"));
const Orders = lazy(() => import("@/pages/admin/Orders"));
const OrderDetail = lazy(() => import("@/pages/admin/OrderDetail"));
const Abandoned = lazy(() => import("@/pages/admin/Abandoned"));
const Analytics = lazy(() => import("@/pages/admin/Analytics"));
const EmailQueue = lazy(() => import("@/pages/admin/EmailQueue"));
const LiveEvents = lazy(() => import("@/pages/admin/LiveEvents"));

const AdminFallback = () => (
  <div className="min-h-screen bg-[#fafaf9] flex items-center justify-center text-[#0e0e10] text-sm">
    Loading admin…
  </div>
);

function App() {
  return (
    <div className="App font-sans">
      <HelmetProvider>
        <BrowserRouter>
          <MetaPixelRouteTracker />
          <Suspense fallback={<AdminFallback />}>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/success" element={<Success />} />
              <Route path="/track" element={<Track />} />
              <Route path="/policies/:slug" element={<Policy />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="orders" element={<Orders />} />
                <Route path="orders/:id" element={<OrderDetail />} />
                <Route path="abandoned" element={<Abandoned />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="live" element={<LiveEvents />} />
                <Route path="emails" element={<EmailQueue />} />
              </Route>
            </Routes>
          </Suspense>
        </BrowserRouter>
      </HelmetProvider>
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
